module.exports = __webpack_public_path__ + "e65310ac65e9631c317bbfa701fd1f3e.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/alert-36.svg
// module id = 1216
// module chunks = 65